export enum CredentialType {
  MASTER = "MASTER",
  USER = "USER",
}

export interface Credential {
  accessKey: string;
  description: string;
  enabled: boolean;
  bucket: string;
  accountCode: string;
}
